// score-thresholds-allow-file: likert label and traffic-light colour scale, no API field serves it
import { ScoreRange } from '@vizit/constants';

/**
 * Returns a likert label for the given score.
 *
 * @param score - Numeric score (0-100), or null for unscored.
 * @param abbreviated - When true, returns "Med" instead of "Medium". Default: false.
 * @returns 'N/A' | 'Low' | 'Med' | 'Medium' | 'High'
 */
export function getLikertLabel(score: number | null, abbreviated = false): string {
  if (score == null) return 'N/A';
  if (score < 40) return 'Low';
  if (score < 80) return abbreviated ? 'Med' : 'Medium';
  return 'High';
}

/**
 * Maps a likert score to the score tier whose accent color represents its band.
 * The likert bar is a red / yellow / green traffic light, so each band borrows the
 * tier carrying that color: Low → red, Medium → yellow (the 60-79 `high` tier),
 * High → green (the 80+ `very-high` tier). This keeps green reserved for 80+, in
 * step with the 5-tier score scale (where `score-moderate` is now orange and
 * `score-high` is yellow).
 */
export function getLikertScoreRange(score: number | null): ScoreRange {
  if (score == null) return ScoreRange.NotApplicable;
  if (score < 40) return ScoreRange.Low; // red
  if (score < 80) return ScoreRange.High; // yellow (Medium band)
  return ScoreRange.VeryHigh; // green (High band, 80+)
}
